import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Day } from '@zenlayer/zen-design';
import t from '@zenlayer/zen-intl18';
import { useRequest } from 'ahooks';
import { getDropDownTeamUsers, } from '../../api/auditlog';
export const useConfiguration = ({ inDetail, }) => {
    const UsersRequest = useRequest(() => getDropDownTeamUsers());
    const configuration = [
        {
            key: 'resEvent',
            label: t('Uk6bd1CsbX2U'),
            match: 'default',
        },
        {
            key: 'resUid',
            label: t('7yqaxLqHFjlg'),
            match: 'uuid',
        },
        {
            key: 'clientIP',
            label: t('oE6eKywJRfmM'),
            match: 'ipv4',
        },
        {
            key: 'userUuid',
            label: t('K5geZXSQ6VtJ'),
            match: 'email',
            options: UsersRequest.data?.data?.map((i) => ({
                label: i.username,
                value: i.userUuid,
            })),
        },
    ];
    if (inDetail) {
        return configuration.filter((i) => i.key !== 'resUid');
    }
    return configuration;
};
export const useColumns = ({ isDefaultPartner, inDetail, params, openDetail, dataAttrs, }) => {
    return [
        {
            dataIndex: 'resEvent',
            title: t('JW7Hzvp0kJOU'),
            width: 220,
            columnsOpts: {
                key: 'resEvent',
                disabled: true,
                defaultChecked: true,
            },
            exportOpts: {
                title: t('JW7Hzvp0kJOU'),
                key: 'resEvent',
                disabled: true,
                defaultChecked: true,
            },
        },
        {
            dataIndex: 'resUid',
            title: t('OZs0qQN91665'),
            width: 262,
            hidden: inDetail,
            columnsOpts: {
                key: 'resUid',
                disabled: true,
                defaultChecked: true,
            },
            exportOpts: {
                title: t('OZs0qQN91665'),
                key: 'resUid',
                disabled: true,
                defaultChecked: true,
            },
        },
        {
            dataIndex: 'clientIP',
            title: t('hVU95mHrjTBa'),
            width: 120,
            columnsOpts: {
                key: 'clientIP',
                disabled: false,
                defaultChecked: true,
            },
            exportOpts: {
                title: t('hVU95mHrjTBa'),
                key: 'clientIP',
                disabled: false,
                defaultChecked: true,
            },
        },
        {
            dataIndex: 'opsUser',
            title: t('s4PFqYUBT6dD'),
            width: 190,
            columnsOpts: {
                key: 'opsUser',
                disabled: false,
                defaultChecked: true,
            },
            exportOpts: {
                title: t('s4PFqYUBT6dD'),
                key: 'opsUser',
                disabled: false,
                defaultChecked: true,
            },
        },
        {
            dataIndex: 'opsTime',
            title: t('69wTBJjb8lpm'),
            width: 120,
            columnsOpts: {
                key: 'opsTime',
                disabled: false,
                defaultChecked: true,
            },
            exportOpts: {
                title: t('69wTBJjb8lpm'),
                key: 'opsTime',
                disabled: false,
                defaultChecked: true,
            },
            render: (v) => _jsx(Day.FromNow, { targetDate: v }),
        },
        {
            dataIndex: '_action',
            title: t('1ypCE7fKsvei'),
            width: 140,
            align: 'center',
            columnsOpts: {
                key: '_action',
                disabled: false,
                defaultChecked: true,
            },
            exportOpts: [
                {
                    title: t('15XFIdYGFAPY'),
                    key: 'resType',
                    disabled: false,
                    defaultChecked: true,
                },
                {
                    title: t('LxfF0dT5sH4F'),
                    key: 'eventSource',
                    disabled: false,
                    defaultChecked: true,
                },
                {
                    title: t('g18MMFvf1jPR'),
                    key: 'apiVersion',
                    disabled: false,
                    defaultChecked: true,
                },
                {
                    title: t('oFRjzWlhDZGk'),
                    key: 'request',
                    disabled: false,
                    defaultChecked: true,
                },
                {
                    title: t('g6CJgcGnLlyS'),
                    key: 'response',
                    disabled: false,
                    defaultChecked: true,
                },
            ],
            render: (_, r) => (_jsx(Button, { ...dataAttrs?.openDetail, size: "s", type: "text", onClick: () => {
                    openDetail({
                        docId: r.docId,
                        isDefaultPartner,
                        ...params,
                    }, { name: r.resEvent });
                }, children: t('Ogp5xxUnNBMM') })),
        },
    ];
};
